class PassportWidget {

    constructor($form, isPassportModule, lockOnId) {
        this.$form = $form;
        this.$addRowButton = $form.find('.form__see-more');
        this.$wrapper = $form.find('.passport-wrapper').first();
        this.$container = $form.find('.passport-container').first();
        this.isPassportModule = isPassportModule
        this.lockOnId = lockOnId;
    }

    addEvents() {
        this.$addRowButton.click(this.addRowHandler.bind(this));

        // add event on dropdown for country and service type
        let countriesInput = this.$form.find('.widget-country').find('.custom-select');
        countriesInput.change(this.inputChangeHandler.bind(this));
        let serviceTypeInput = this.$form.find('.widget-service-type').find('.custom-select');
        serviceTypeInput.change(this.inputChangeHandler.bind(this));
    }

    getRelatedName(name){
        switch (name) {
            case "country_id":
                return "countries";
            case "service_type_id":
                return "service_types";
            case "number_of_page_id":
                return "number_page_options";
        }
        return name;
    }

    intiFromRequest() {
        // if(!this.isPassportModule)
        //     return;

        // try take from the request
        const params = new URLSearchParams(window.location.search);
        let requestObj = {};

        for (const param of params) {
            let paramName = param[0].substring(param[0].lastIndexOf('[') + 1, param[0].lastIndexOf(']'));
            paramName = this.getRelatedName(paramName);
            let paramVal = param[1];
            let rowId = param[0].match('\\[(.*?)\\]')[1];
            if(!requestObj[rowId]){
                requestObj[rowId] = {};
            }
            requestObj[rowId][paramName] = paramVal;
        }

        // if is not old request, and is locked widget country then we check only by country
        if(Object.keys(requestObj).length === 0 && this.lockOnId){
            // here we have only one row, initial one, rowId = 0
            const rowId = 0;
            let country = this.$form.find('#documents_' + rowId + '_country_id');
            this.populateNoOfPageOption({ countries: country.val() }, rowId);
        }

        for(let rowId in requestObj){
            this.populateNoOfPageOption(requestObj[rowId], rowId);
        }
    }

    addRowHandler(){
        let rows = this.$form.find('.passport-wrapper');
        if (rows.length >= 4) {
            return;
        }
        let index = rows.length;
        let $clone = this.$wrapper.clone().hide();
        let $select = $clone.find('select.custom-select');

        for(let i=0; i<$select.length; i++){
            let $sel = $($select[i]);
            $sel.val('');
            $sel.attr('name', $sel.prop('name').replace('[0]', '[' + index + ']'));
            $sel.attr('id', $sel.prop('id').replace('_0', '_' + index));
            $sel.attr('row', index);
        }

        let countriesInput = $clone.find('.widget-country').find('.custom-select');
        if(this.lockOnId != -1){
            let $input = $clone.find('input');
            countriesInput.val(this.lockOnId);
            for(let j=0; j<$input.length; j++){
                let $sel = $($input[j]);
                $sel.val(this.lockOnId);
                $sel.attr('name', $sel.prop('name').replace('[0]', '[' + index + ']'));
                $sel.attr('id', $sel.prop('id').replace('_0', '_' + index));
                $sel.attr('row', index);
            }
        }
        countriesInput.change(this.inputChangeHandler.bind(this));
        let serviceTypeInput = $clone.find('.widget-service-type').find('.custom-select');
        serviceTypeInput.change(this.inputChangeHandler.bind(this));

        $clone.find('.remove-country-row').first().removeClass('d-none');
        $clone.appendTo(this.$container).show('fast');
    }

    inputChangeHandler(event) {
        // if(!this.isPassportModule)
        //     return;

        let $target = $(event.target);
        if($target.attr("row") < 0){
            return;
        }
        let country = this.$form.find('#documents_' + $target.attr("row") + '_country_id');
        let serviceType = this.$form.find('#documents_' + $target.attr("row") + '_service_type_id');

        let params = {
            rowId : $target.attr("row"),
            countries: country.val(),
            service_types: serviceType.val(),
            number_page_options: null
        };

        // populate no of pages option
        this.populateNoOfPageOption(params, $target.attr("row"));
    }


    populateNoOfPageOption(params, rowId) {
        let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        params['CSRF'] = token;

        axios.get(this.$form.data('requirements'), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            params: params
        }).then(response => this.populateNoOfPageOptionHandler(response.data, rowId))
            .catch(error => console.log(error));
    }

    populateNoOfPageOptionHandler(data, rowId) {
        if(!data || rowId < 0)
            return;

        let $numberPageOption = this.$form.find('#documents_' + rowId + '_number_of_page_id');
        let $serviceType =  this.$form.find('#documents_' + rowId + '_service_type_id');

        // disable if no options exists
        if(!data){
            $numberPageOption.find('option').remove().end().disable();
            $serviceType.find('option').remove().end().disable();
            return;
        }
        // if(data.serviceTypes.length === 0){
        //     $serviceType.find('option').remove().end().disable();
        // }
        // if(data.no_option_page.length === 0){
        //     $numberPageOption.find('option').remove().end().disable();
        // }

        $serviceType.find('option').remove();
        data.serviceTypes.forEach(function(elem){
            $serviceType.append(`<option ${elem.selected} value="${elem.value}">${elem.trans}</option>`);
        });

        $numberPageOption.find('option').remove();
        data.no_option_page.forEach(function(elem){
            $numberPageOption.append(`<option ${elem.selected} value="${elem.value}">${elem.trans}</option>`);
        });
    }
}

window.PassportWidget = PassportWidget;